import { lazy } from 'react'

export const FeltHelplessVariant1 = lazy(() => import('./FeltHelplessVariant1'))
